import { call, put, takeLatest } from 'redux-saga/effects'

import { NOTIFICATION_TYPE } from '~/common/constants'
import addNotification from '~/utils/toast'

import {
  actUpdateFactoryFailed,
  actUpdateFactorySuccess,
  MASTER_UPDATE_FACTORY,
} from '../../actions/factory'
import { apiUpdateFactory, apiUpdateChooseOrg } from '../../apis/factory'

/**
 * Handle get data request and response
 * @param {object} action
 */
function* doUpdate(action) {
  try {
    const isChoosseOrg = !!action?.payload.orgStructureIds
    const response = yield call(
      isChoosseOrg ? apiUpdateChooseOrg : apiUpdateFactory,
      action?.payload,
    )

    if (response?.statusCode === 200) {
      // Call callback action if provided
      yield put(actUpdateFactorySuccess(response))

      if (action.onSuccess) {
        yield action.onSuccess()
      }
      addNotification(
        isChoosseOrg
          ? 'factory.notification.addOrgSuccess'
          : 'factory.notification.updateSuccess',
        NOTIFICATION_TYPE.SUCCESS,
      )
    } else {
      addNotification(
        isChoosseOrg ? 'factory.notification.addOrgError' : response?.message,
        NOTIFICATION_TYPE.ERROR,
      )
      throw new Error(response?.message)
    }
  } catch (error) {
    yield put(actUpdateFactoryFailed())
    // Call callback action if provided
    if (action.onError) {
      yield action.onError(error)
    }
  }
}

export default function* watchUpdate() {
  yield takeLatest(MASTER_UPDATE_FACTORY, doUpdate)
}
